import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';

type RuntimeAppConfig = {
  API_BASE_URL?: string;
  WEBSITE_URL?: string;
};

@Injectable({
  providedIn: 'root'
})
export class Globals {
  readonly backendUri: string = this.resolveBackendUrl();
  readonly websiteUrl: string = this.resolveWebsiteUrl();

  private resolveBackendUrl(): string {
    const runtimeBaseUrl = this.readRuntimeApiBaseUrl();
    if (runtimeBaseUrl) {
      return this.removeTrailingSlash(runtimeBaseUrl);
    }

    const configuredBaseUrl = environment.apiBaseUrl?.trim();
    if (configuredBaseUrl) {
      return this.removeTrailingSlash(configuredBaseUrl);
    }
    return this.removeTrailingSlash(window.location.origin + '/api/v1');
  }

  private resolveWebsiteUrl(): string {
    const runtimeConfig = (window as Window & { __APP_CONFIG__?: RuntimeAppConfig }).__APP_CONFIG__;
    const runtimeWebsiteUrl = runtimeConfig?.WEBSITE_URL?.trim();
    return this.removeTrailingSlash(runtimeWebsiteUrl || 'https://mastering-emotions.pages.dev');
  }

  private readRuntimeApiBaseUrl(): string | undefined {
    const runtimeConfig = (window as Window & { __APP_CONFIG__?: RuntimeAppConfig }).__APP_CONFIG__;
    return runtimeConfig?.API_BASE_URL?.trim();
  }

  private removeTrailingSlash(url: string): string {
    return url.endsWith('/') ? url.slice(0, -1) : url;
  }
}
